import React from "react";
import styled from "styled-components";
import { useSelector } from "react-redux";

const DocumentListBlock = styled.div`
  overflow: hidden;
  min-width: 20%;
`;

const DocumentListMenu = styled.div`
  margin-bottom: 20px;
`;

const SectionHeader = styled.div`
  font-size: 1rem;
  font-weight: bold;
  padding: 10px;
  margin-bottom: 0;
  border-radius: 5px 5px 0px 0px;
  color: white;
  background-color: ${(props) => props.colors.componentHeaderBackground};
`;

const ResourceList = styled.div`
  list-style-type: none;
  border-radius: 0px 0px 5px 5px;
  background-color: ${(props) => props.colors.formBackground};
  margin-top: 0;
  font-size: 12px;
`;

const ProgressTable = styled.table`
  width: 100%;

  border-collapse: collapse;

  th,
  td {
    text-align: left;
    padding: 10px;
  }

  th {
    background-color: #FFF;
    font-weight: bold;
  }

  tr:nth-child(even) {
    background-color: #FFF;
  }

  tr:nth-child(odd) {
    background-color: #dcdcdc;
  }

  td {
    color: #000;
  }
`;

const ModuleProgress = ({ colors }) => {
  // Accessing state data using Redux
  const chapters = useSelector((state) => state.ilearn.chapters);
  const modules = useSelector((state) => state.ilearn.modules);

  // Generate module progress data dynamically
  const completedModules = Object.keys(chapters)
    .filter(
      (moduleNo) =>
        chapters[moduleNo].completedChapters === chapters[moduleNo].totalChapters
    )
    .map((moduleNo) => {
      const moduleData = chapters[moduleNo];
      const lastChapter = moduleData.chapters[moduleData.chapters.length - 1];
      const moduleName = modules[moduleNo]?.module_name || "Unknown Module";
      const formattedDate = lastChapter.watch_date
      ? new Date(lastChapter.watch_date).toISOString().split("T")[0]
      : "N/A";

      return {
        date: formattedDate,
        portal: "EDUMODULES",
        completedModule: moduleName,
      };
    });

  return (
    <DocumentListBlock>
      <DocumentListMenu>
        <SectionHeader colors={colors}>Module Progress</SectionHeader>
        <ResourceList colors={colors}>
          {completedModules.length > 0 ? (
            <ProgressTable>
              <thead>
                <tr>
                  <th></th>
                  <th>Date</th>
                  <th>ILEARN Portal</th>
                  <th>Module(s) Completed</th>
                </tr>
              </thead>
              <tbody>
                {completedModules.map((module, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{module.date || "N/A"}</td>
                    <td>{module.portal}</td>
                    <td>{module.completedModule}</td>
                  </tr>
                ))}
              </tbody>
            </ProgressTable>
          ) : (
            <p style={{ color: "#333", fontSize: "14px", padding: "10px", marginTop: 0 , textAlign: 'center'}}>
              No modules completed yet.
            </p>
          )}
        </ResourceList>
      </DocumentListMenu>
    </DocumentListBlock>
  );
};

export default ModuleProgress;
